<template>
  <div>
    <v-row lass="justify-start ml-2 mr-2">
      <v-col
        cols="12"
        md="6"
        sm="12"
      >
        <v-tooltip
          max-width="500"
          top
        >
          <template v-slot:activator="{ on }">
            <div v-on="on">
              <select-simple-unidade
                :value="unidade"
                :lista-unidades="unidades"
              />
            </div>
          </template>
          <div>Selecione para carregar os dados de outra unidade.</div>
        </v-tooltip>
      </v-col>
    </v-row>
    <v-row v-if="relatorio">
      <v-col>
        <component
          :is="tipoMonitoramento"
          :relatorio="relatorio"
          :ano="`${anoAtual}`"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Data from '@/modules/data';
import SelectSimpleUnidade from '@/components/SelectSimpleUnidade';
import Cadastro from '@/components/monitoramento/perfil/relatorio/cadastro/RelatorioPerfilUnidadeCadastro';
import Formacao from '@/components/monitoramento/perfil/relatorio/formacao/RelatorioPerfilUnidadeFormacao';
import Profissional
from '@/components/monitoramento/perfil/relatorio/profissional/RelatorioPerfilUnidadeProfissional';
import Interesse from '@/components/monitoramento/perfil/relatorio/interesse/RelatorioPerfilUnidadeInteresse';
import Preferencia from '@/components/monitoramento/perfil/relatorio/preferencia/RelatorioPerfilPreferencia';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const monitoramentoRepository = RepositoryFactory.get('monitoramento');

export default {
  name: 'RelatorioPerfilUnidade',

  components: {
    SelectSimpleUnidade,
    Cadastro,
    Formacao,
    Profissional,
    Interesse,
    Preferencia,
  },

  props: {
    tipoMonitoramento: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      unidade: { selecionado: null },
      relatorio: null,
    };
  },

  computed: {
    ...mapState({
      unidades: (state) => state.unidade.unidades,
    }),
    anoAtual() {
      return Data.get().year();
    },
  },

  watch: {
    'unidade.selecionado': function (value) {
      const payload = {
        isMacro: false,
        categoria: 'TODOS',
        unidades: [value.id],
      };
      monitoramentoRepository.getRelatorioPerfil(payload).then((response) => {
        this.relatorio = response.data.unidades.find((rU) => rU.id === value.id);
        this.$store.dispatch('app/success', { response, message: '' });
      });
    },
  },
};
</script>
